import { type StripeElementStyle, type StripeElementsOptions } from '@stripe/stripe-js';

const rootElementOptions: StripeElementsOptions = {
  fonts: [
    {
      cssSrc: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700&display=swap',
    },
  ],
};

const desktopFieldStyles: StripeElementStyle = {
  base: {
    fontFamily: "'Montserrat', sans-serif",
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '16px',
    color: '#181F26',
    lineHeight: '20px',
    letterSpacing: '0.1px',
    '::placeholder': {
      color: 'rgba(24, 31, 38, 0.3)',
    },
  },
  invalid: {
    color: '#181F26',
  },
};

const mobileFieldStyles: StripeElementStyle = {
  base: {
    fontFamily: "'Montserrat', sans-serif",
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '14px',
    color: '#181F26',
    lineHeight: '17px',
    letterSpacing: '0.1px',
    '::placeholder': {
      color: 'rgba(24, 31, 38, 0.3)',
    },
  },
  invalid: {
    color: '#181F26',
  },
};

export { rootElementOptions, desktopFieldStyles, mobileFieldStyles };
